/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { SemanticDomain } from "./semantic-domain";

/**
 *
 * @export
 * @interface SemanticDomainTreeNode
 */
export interface SemanticDomainTreeNode {
  /**
   *
   * @type {string}
   * @memberof SemanticDomainTreeNode
   */
  mongoId?: string | null;
  /**
   *
   * @type {string}
   * @memberof SemanticDomainTreeNode
   */
  lang: string;
  /**
   *
   * @type {string}
   * @memberof SemanticDomainTreeNode
   */
  guid: string;
  /**
   *
   * @type {string}
   * @memberof SemanticDomainTreeNode
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof SemanticDomainTreeNode
   */
  id: string;
  /**
   *
   * @type {SemanticDomain}
   * @memberof SemanticDomainTreeNode
   */
  previous?: SemanticDomain;
  /**
   *
   * @type {SemanticDomain}
   * @memberof SemanticDomainTreeNode
   */
  next?: SemanticDomain;
  /**
   *
   * @type {SemanticDomain}
   * @memberof SemanticDomainTreeNode
   */
  parent?: SemanticDomain;
  /**
   *
   * @type {Array<SemanticDomain>}
   * @memberof SemanticDomainTreeNode
   */
  children: Array<SemanticDomain>;
}
